/**
 * BrandLandingRouter — selects which landing page renders at `/`.
 *
 * Reads the active brand from the `useBrand` hook (which resolves from
 * hostname + ?brand= override + localStorage) and returns the matching
 * component. Lives outside the route definitions so the choice is
 * trivially testable.
 */
import React from 'react';
import { useBrand } from './useBrand';

const BrandLandingRouter = ({ stays, marketplace }) => {
  const { brandKey } = useBrand();
  return brandKey === 'marketplace' ? marketplace : stays;
};

export default BrandLandingRouter;
